import * as _ from 'lodash';
import * as qs from 'query-string';
import React, { Component } from 'react';
import { Dispatch, connect } from 'react-redux';
import { IRecipient, IRecipientSearchReportLookupData, IBaseResponse } from '@nkr/models/index';
import { IApplicationState, AppActionCreators, IAppState, RecipientActionCreators, IRecipientRequest, IAdminRecipientListResponse, IAdminRecipientSaveResponse, IRecipientLookupResponse, IRecipientDataResponse, IRecipientReportLogResponse, IAdminUpdateRecipientRequest } from '@nkr/store/index';
import { Alert, Button, Glyphicon } from 'react-bootstrap';
import { toast } from 'react-toastify';
import { AxiosError } from 'axios';
import { IFilterData } from './filter-data';
import MediaQuery from 'react-responsive';
import Loader from 'react-spinners/ClockLoader';
import View from './view';
import Drawer from 'rc-drawer';
import Grid from './grid';
import Filter from './filter';
import ActionsDropdown from './actions-dropdown';

interface IProps {
    centerId: number
}

interface IStateProps {
    app: IAppState
}

interface IDispatchProps {
    showLoading: (message: string) => Promise<void>,
    hideLoading: () => void,
    getRecipientSearchList: (request: IRecipientRequest) => Promise<IAdminRecipientListResponse>,
    getRecipientLookUp: (centerId: number, isAdmin: boolean) => Promise<IRecipientLookupResponse>,
    getRecipientData: (recipientId: number) => Promise<IRecipientDataResponse>,
    saveAdmin: (recipientId: number, request: IAdminUpdateRecipientRequest) => Promise<IAdminRecipientSaveResponse>,
    deleteLogEntry: (id: number) => Promise<IBaseResponse>,
    saveLogEntry: (id: number, dashRegistrationId: number, actionTaken: number, comments: string) => Promise<IRecipientReportLogResponse>,
}

type TProps = IProps & IStateProps & IDispatchProps;

interface IState {
    list: IRecipient[],
    lookupData: IRecipientSearchReportLookupData,
    filterData: IFilterData,
    fetching: boolean,
    userFilter: number,
    statusFilter: number,
    showFilter: number,
    view: {
        show: boolean,
        data: IRecipient,
        currentCenterId: number
    },
    confirmview: {
        show: boolean,
        formdata: IRecipient
    },
    clearValidation: boolean
}

class RecipientSearch extends Component<TProps, IState> {
    readonly state: IState = {
        list: [],
        lookupData: {
            centerList: [],
            clusterList: [],
            positionList: [],
            logisticsList: [],
            desensitizationList: [],
            donorRelationList: [],
            transportMethodList: [],
            swapList: [],
            chainList: [],
            stateList: [],
            voucherStatusList: [],
            coordinatorList: [],
            matchStatusList: [],
            patientTypeList: [],
            recipientReportLogActionList: [],
            recipientInactiveReasonList: [],
            compatiblePairKpdReasonList: [],
            deleteReasonList: [],
            insuranceGroupList: [],
            hlaValueList: [],
            raceList: [],
            antiATiterValueList: [],
            contactList: [],
            acuteAMRGradeList: [],
            acuteTCMRGradeList: [],
            biopsyReasonList: [],
            iftaGradeList: [],
            rejectionDSATypeList: [],
            rejectionTreatmentTypeList: [],
            graftFailureReasonList: []
        },
        filterData: {
            centerId: 0,
            show: 0,
            status: 0,
            alias: '',
            phiEmail: '',
            dob: '',
            recipientId: 0
        },
        fetching: false,
        userFilter: -1,
        statusFilter: -1,
        showFilter: 0,
        view: {
            show: false,
            data: null,
            currentCenterId: 0
        },
        confirmview: {
            show: false,
            formdata: null
        },
        clearValidation: false
    }

    intervalId: any;
    container: HTMLDivElement;

    saveContainer = (container: HTMLDivElement) => {
        this.container = container;
    };

    getContainer = () => {
        return this.container;
    };

    componentDidMount = () => {
        this.getData(true);
    }

    getData = (message: boolean) => {
        let q = qs.parse(location.search);

        let recpRequest: IRecipientRequest = {
            centerId: q.cid != null ? q.cid : this.state.filterData.centerId,
            show: q.show != null ? q.show : this.state.filterData.show,
            status: q.status != null ? q.status : this.state.filterData.status,
            alias: q.alias != null ? q.alias : this.state.filterData.alias,
            phiEmail: q.email != null ? q.email : this.state.filterData.phiEmail,
            dob: q.dob != null ? q.dob : this.state.filterData.dob
        }

        let filterData: IFilterData = { ...recpRequest, recipientId: q.rid != null ? parseInt(q.rid) : 0 }

        if (q.cid || q.show || q.status || q.alias || q.email || q.dob || q.rid) {
            let start = message ? this.props.showLoading('Getting recipients, one moment please...') : Promise.resolve(null);

            start.then(() => {
                this.setState({
                    fetching: message == true ? false : true
                }, () => {
                    Promise.all([
                        this.props.getRecipientSearchList(recpRequest),
                        this.props.getRecipientLookUp(recpRequest.centerId, true)
                    ])
                        .then(([listResponse, lookupDataResponse]) => {
                            if (listResponse.data.success && lookupDataResponse.data.success) {
                                let list = listResponse.data.results;

                                this.setState({
                                    list,
                                    lookupData: lookupDataResponse.data.results,
                                    filterData,
                                    fetching: false,
                                }, () => {
                                    this.setConversionUrl(filterData);

                                    if (filterData.recipientId > 0) {
                                        this.handleViewRegistration(filterData.recipientId);
                                    }
                                });
                            }
                        })
                        .finally(() => {
                            this.props.hideLoading();
                        });
                });
            });
        }
    }

    handleCancelView = () => {
        let filterData = { ...this.state.filterData, recipientId: 0 };

        this.setState({
            filterData,
            view: {
                show: false,
                data: null,
                currentCenterId: 0
            }
        }, () => {
            this.setConversionUrl(filterData);
        });
    }

    handleViewRegistration = (id: number) => {
        this.props.showLoading('Getting registration Information, one moment please...').then(() => {
            this.props.getRecipientData(id)
                .then(response => {
                    if (response.data.success) {
                        let data = response.data.results;

                        this.setState({
                            view: {
                                show: true,
                                data,
                                currentCenterId: data.centerId
                            }
                        }, () => {
                            let filterData = { ...this.state.filterData, recipientId: id }
                            this.setConversionUrl(filterData);
                        });
                    }
                })
                .finally(() => {
                    this.props.hideLoading();
                });
        });
    }

    handleViewDataChange = (data: IRecipient) => {
        this.setState({
            view: { ...this.state.view, data }
        });
    }

    handleSave = (data: IRecipient) => {
        let request: IAdminUpdateRecipientRequest = {
            currentCenterId: this.state.view.currentCenterId,
            centerId: data.centerId,
            alias: data.alias,
            isDeleted: data.isDeleted,
            isActive: data.isActive,
            patientTypeId: data.patientTypeId,
            statusId: data.statusId,
            bloodType: data.bloodType,
            sendComplianceEmails: data.sendComplianceEmails,
            mrn: data.mrn,
            firstName: data.firstName,
            lastName: data.lastName,
            isSwapSaver: data.isSwapSaver,
            isRealTimeSwapFailure: data.isRealTimeSwapFailure,
            gender: data.gender,
            birthDate: data.birthDate,
            inactiveReason: data.inactiveReason,
            chainId: data.chainNumber,
            clusterNumber: data.clusterNumber,
            positionNumber: data.position,
            targetedChainEnd: data.targetedChainEnd
        };

        this.props.showLoading('Saving recipient data, one moment please...').then(() => {
            this.props.saveAdmin(data.id, request)
                .then(async response => {
                    let list = _.cloneDeep(this.state.list).map(item => {
                        if (item.id == data.id) {
                            return response.data.results;
                        }
                        return item;
                    });

                    let viewResponse = await this.props.getRecipientData(data.id);

                    this.setState({
                        list,
                        view: { ...this.state.view, data: viewResponse.data.results }
                    });

                    toast.success('Recipient data saved successfully...');
                })
                .catch((error: AxiosError) => {
                    toast.error(
                        <>
                            <div>Unable to create linked records:</div>
                            <div>{error.message}</div>
                        </>
                    );
                })
                .finally(() => {
                    this.props.hideLoading();
                });
        });
    }

    handleFilterUpdate = (filterData: IFilterData) => {
        this.setState({
            filterData
        });
    }

    handleSearch = () => {
        this.props.showLoading('Searching, one moment please..').then(() => {
            Promise.all([
                this.props.getRecipientSearchList(this.state.filterData),
                this.props.getRecipientLookUp(this.state.filterData.centerId, true)
            ])
                .then(([listResponse, lookupDataResponse]) => {
                    if (listResponse.data.success && lookupDataResponse.data.success) {
                        this.setState({
                            list: listResponse.data.results,
                            lookupData: lookupDataResponse.data.results,
                        }, () => {
                            this.setConversionUrl(this.state.filterData);
                        });
                    }
                })
                .finally(() => {
                    this.props.hideLoading();
                });
        });
    }

    setConversionUrl = (data: IFilterData) => {
        let {
            centerId,
            show,
            status,
            alias,
            dob,
            recipientId
        } = data;

        let paramList = [];

        if (centerId > 0) {
            paramList.push(encodeURI('cid=' + centerId));
        }

        if (show != 0) {
            paramList.push(encodeURI('show=' + show));
        }

        if (status != 0) {
            paramList.push(encodeURI('status=' + status));
        }

        if (alias != '') {
            paramList.push(encodeURI('alias=' + alias));
        }

        if (dob != '') {
            paramList.push(encodeURI('dob=' + dob));
        }

        if (recipientId > 0) {
            paramList.push(encodeURI('rid=' + recipientId));
        }

        let params = paramList.join('&');

        let newUrl = '/admin/recipient-search?' + params;

        window.history.pushState({}, '', newUrl);
    }

    render = () => {
        return (
            <>
                <div ref={this.saveContainer}></div>

                <div style={{ display: 'flex', justifyContent: 'space-between', flexWrap: 'wrap', marginBottom: 10 }}>
                    <div style={{ display: 'flex', alignItems: 'center' }}>
                        <div style={{ fontSize: 28, fontWeight: 500 }}>RECIPIENTS</div>
                        <div style={{ display: 'flex' }}>
                            {this.state.fetching && (
                                <>
                                    <div style={{ marginRight: 5 }}>Fetching recipients...</div>
                                    <Loader size={20} color={'#a1a1a1'} />
                                </>
                            )}
                        </div>
                    </div>
                </div>

                <MediaQuery minWidth={1023}>
                    <Filter
                        centerId={this.props.centerId}
                        centerList={this.state.lookupData.centerList}
                        filterData={this.state.filterData}
                        onUpdateFilter={this.handleFilterUpdate}
                        onSearch={this.handleSearch}
                    />

                    <Grid
                        data={this.state.list}
                        centerId={this.props.centerId}
                        showPanel={this.state.view.show}
                        onViewRegistration={this.handleViewRegistration}
                    />

                    <div style={{ marginBottom: 5 }}>{this.state.list.length} of {this.state.list.length} records shown...</div>

                    <Drawer
                        width="35vw"
                        placement="right"
                        getContainer={this.getContainer}
                        open={this.state.view.show}
                        style={{ zIndex: 99999999 }}
                    >
                        <div style={{ height: '100%', display: 'flex', flexDirection: 'column', justifyContent: 'space-between' }}>
                            <div style={{ padding: 10 }}>
                                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 5 }}>
                                    <h3 style={{ margin: 0, width: '33%' }}>Recipient Details</h3>
                                    <div>
                                        <ActionsDropdown
                                            centerId={this.state.view.data != null ? this.state.view.data.centerId : 0}
                                            recipient={this.state.view.data}
                                            showLinkToDetails={true}
                                            showBsMenu={true}
                                            showOption={true}
                                            onMenuToggle={() => null}
                                            onItemSelected={() => null}
                                        />
                                    </div>
                                    <div style={{ width: '33%', textAlign: 'right' }}>
                                        <Button bsStyle='link' bsSize='sm' onClick={this.handleCancelView}><Glyphicon glyph='remove' /></Button>
                                    </div>
                                </div>

                                <View
                                    data={this.state.view.data}
                                    lookupData={this.state.lookupData}
                                    onSave={this.handleSave}
                                    onDataChange={this.handleViewDataChange}
                                />
                            </div>

                            <div className='text-center bg-info'>
                                <Button bsStyle='link' block onClick={this.handleCancelView}>Close This View</Button>
                            </div>
                        </div>
                    </Drawer>
                </MediaQuery>

                <MediaQuery maxWidth={1023}>
                    <View
                        data={this.state.view.data}
                        lookupData={this.state.lookupData}
                        onSave={this.handleSave}
                        onDataChange={this.handleViewDataChange}
                    />
                </MediaQuery>
            </>
        );
    }
}

const mapStateToProps = (state: IApplicationState): IStateProps => {
    return {
        app: state.app
    };
}

const mapDispatchToProps = (dispatch: Dispatch<any>): IDispatchProps => {
    return {
        showLoading: (message) => {
            return dispatch(AppActionCreators.showLoadingAsync(message));
        },
        hideLoading: () => {
            return dispatch(AppActionCreators.hideLoading());
        },
        getRecipientSearchList: (request) => {
            return dispatch(RecipientActionCreators.getAdminRecipientList(request));
        },
        getRecipientLookUp: (centerId, isAdmin) => {
            return dispatch(RecipientActionCreators.getRecipientLookup(centerId, isAdmin));
        },
        getRecipientData: (recpId) => {
            return dispatch(RecipientActionCreators.getRecipientData(recpId));
        },
        saveAdmin: (recipientId, data) => {
            return dispatch(RecipientActionCreators.saveAdmin(recipientId, data));
        },
        deleteLogEntry: (id) => {
            return dispatch(RecipientActionCreators.deleteRecipientLogEntry(id));
        },
        saveLogEntry: (id, recipientReportId, actionTaken, comments) => {
            return dispatch(RecipientActionCreators.saveRecipientLogEntry(id, recipientReportId, actionTaken, comments));
        },
    };
}

export default connect<IStateProps, IDispatchProps, IProps>(
    mapStateToProps,
    mapDispatchToProps)(RecipientSearch);